import { InvoiceStatus } from '@cyberlabrs/helpers';
import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

interface StatusBadgeProps {
    status: string;
    className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
    const { t } = useTranslation('invoice');
    const getStatusClass = (status: string): string[] => {
        switch (status) {
            case InvoiceStatus.SENT:
                return ['status-badge--paid', t('sent')];
            case InvoiceStatus.PAID:
                return ['status-badge--paid', t('paid')];
            case InvoiceStatus.DRAFT:
                return ['status-badge--draft', t('draft')];
            case InvoiceStatus.READY:
                return ['status-badge--ready', t('ready')];
            case InvoiceStatus.SENDING_FAILED:
                return ['status-badge--overdue', t('sendingFailed')];
            case InvoiceStatus.OVERDUE:
                return ['status-badge--overdue', t('overdue')];
            default:
                return [className, status];
        }
    };

    return <span className={`status-badge ${getStatusClass(status)[0]} ${className}`}>{getStatusClass(status)[1]}</span>;
};

export default StatusBadge;
